import { Component, Inject } from '@angular/core';

@Component({
  selector: 'ut-unified-signup-error',
  templateUrl: './error.component.html',
  standalone: false,
})
export class UnifiedRegistrationErrorComponent {
  constructor(@Inject('$window') private $window: any) { }

  goToLogin(): void {
    this.$window.location.href = '/login';
  }
}

export default UnifiedRegistrationErrorComponent;
